<template>
  <div class="contact-detail">
    <div class="nav">
      <div class="nav-l">
        <div
          class="nav-l-tab"
          :class="{ isActive: activeTab === item.type }"
          v-for="item in tabs"
          :key="item.id"
          @click="changeTab(item.type)"
        >
          <template v-if="item.show">
            {{ item.name }}
          </template>
        </div>
      </div>
    </div>
    <div class="tabs" v-if="contactData">
      <div class="tabs-container">
        <template v-if="activeTab === 'basic'">
          <!-- <div class="header">
            <div class="header-left"></div>
            
          </div> -->
          <el-form
            ref="ruleForm"
            :model="contactData"
            :rules="rules"
            label-width="120px"
            label-position="left"
          >
            <div class="head-title">基本信息</div>
            <div class="info-item">
              <el-form-item v-if="contactData.customer_name" label="关联客户">
                <span v-if="contact.status === 'readonly'">{{
                  contactData.customer_name
                }}</span>
                <el-input
                  v-else
                  v-model="contactData.customer_name"
                  style="width: 35%"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item v-if="contactData.leads_name" label="关联线索">
                <span v-if="contact.status === 'readonly'">{{
                  contactData.leads_name
                }}</span>
                <el-input
                  v-else
                  v-model="contactData.leads_name"
                  style="width: 35%"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="姓名" prop="name">
                <span v-if="contact.status === 'readonly'">{{
                  contactData.name
                }}</span>
                <el-input
                  v-else
                  v-model="contactData.name"
                  placeholder="请输入姓名"
                  style="width: 220px"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="职位">
                <span v-if="contact.status === 'readonly'">{{
                  contactData.post
                }}</span>
                <el-input
                  v-else
                  v-model="contactData.post"
                  placeholder="请输入职位"
                  style="width: 220px"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <span v-if="contact.status === 'readonly'">{{
                  contactData.sex == "1" ? "男" : "女"
                }}</span>
                <el-select v-else v-model="contactData.sex" clearable>
                  <el-option
                    v-for="item in sex"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <el-divider></el-divider>
            <div class="head-title">联系信息</div>
            <div class="info-item">
              <el-form-item label="手机" required>
                <template v-for="(p, idx) of contactData.mobile">
                  <div class="phone-line" :key="idx">
                    <span v-if="contact.status === 'readonly'">{{
                      contactData.mobile[idx].tel
                    }}</span>
                    <template v-else>
                      <el-input
                        v-model.trim="contactData.mobile[idx].tel"
                        placeholder="请输入手机"
                        style="width: 220px"
                        @blur="onCheckTel(contactData.mobile[idx])"
                        clearable
                      ></el-input>
                      <el-button
                        :style="{ display: idx == 0 ? 'none' : '' }"
                        class="add-btn"
                        icon="el-icon-zoom-out"
                        @click="delPhone(contactData.mobile, idx)"
                      ></el-button>
                      <el-button
                        class="add-btn"
                        icon="el-icon-zoom-in"
                        v-if="idx == contactData.mobile.length - 1"
                        @click="addPhone(contactData.mobile)"
                      ></el-button>
                      <p
                        v-if="contactData.mobile[idx].code == 99"
                        style="color: #f56c6c; margin-left: 20px"
                      >
                        <i class="el-icon-error" style="margin-right: 4px"></i>
                        <span>{{ contactData.mobile[idx].errorMsg }}</span>
                      </p>
                      <p
                        v-if="contactData.mobile[idx].code == 1"
                        style="color: #67c23a; margin-left: 20px"
                      >
                        <i
                          class="el-icon-success"
                          style="margin-right: 4px"
                        ></i>
                        <span>{{ contactData.mobile[idx].errorMsg }}</span>
                      </p>
                    </template>
                  </div>
                </template>
              </el-form-item>
              <el-form-item label="固定电话" prop="telephone">
                <span v-if="contact.status === 'readonly'">{{
                  contactData.telephone
                }}</span>
                <el-input
                  v-else
                  v-model="contactData.telephone"
                  placeholder="请输入固定电话"
                  style="width: 220px"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="邮箱">
                <span v-if="contact.status === 'readonly'">{{
                  contactData.email
                }}</span>
                <el-input
                  v-else
                  v-model="contactData.email"
                  placeholder="请输入邮箱"
                  style="width: 220px"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="地址">
                <span v-if="contact.status === 'readonly'">{{
                  contactData.address
                }}</span>
                <el-cascader
                  v-else
                  v-model="contactData.addressCode"
                  :options="area"
                  clearable
                ></el-cascader>
              </el-form-item>
              <el-form-item label="详细地址">
                <span v-if="contact.status === 'readonly'">{{
                  contactData.detail_address
                }}</span>
                <el-input
                  v-else
                  v-model="contactData.detail_address"
                  placeholder="请输入详细地址"
                  style="width: 35%"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <el-divider></el-divider>
            <div class="head-title">其它信息</div>
            <div class="info-item">
              <el-form-item label="备注">
                <span v-if="contact.status === 'readonly'">{{
                  contactData.remark
                }}</span>
                <el-input
                  v-else
                  placeholder="请输入备注"
                  v-model="contactData.remark"
                  style="width: 35%"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <el-divider></el-divider>
            <template v-if="contact.status === 'readonly'">
              <div class="head-title">系统信息</div>
              <div class="info-item">
                <el-form-item label="负责人">
                  <span v-if="contact.status === 'readonly'">
                    {{ contactData.owner_name }}
                  </span>
                </el-form-item>
                <el-form-item label="创建时间">
                  <span v-if="contact.status === 'readonly'">{{
                    contactData.createtime | formatDate
                  }}</span>
                </el-form-item>
                <el-form-item label="更新于">
                  <span v-if="contact.status === 'readonly'">{{
                    contactData.updatetime | formatDate
                  }}</span>
                </el-form-item>
              </div>
              <el-divider></el-divider>
            </template>
          </el-form>
        </template>
        <logger
          v-if="activeTab === 'log'"
          :data="contact"
          types="contacts"
        ></logger>
      </div>
      <div class="detail-bottom">
        <div class="header-right">
              <div class="head-menu">
                <div class="head-menu-left">
                  <el-button
                    type="primary"
                    v-if="contact.status === 'edit'"
                    :disabled="lockSave"
                    @click="submitForm"
                  >
                    <i class="iconfont iconbaocun"></i>
                    保存
                  </el-button>
                </div>
              </div>
            </div>
      </div>
    </div>
  </div>
</template>
<script>
import logger from "@/components/Logger";
import { readContacts, editContacts } from "@/api/common";
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
import { rules } from "@/mixins/rule.js";
import { checkPhone } from "@/api/common";

export default {
  name: "ContactDetail",
  inject: ["reload"],
  mixins: [rules],
  components: {
    logger,
  },
  data() {
    return {
      rules: {
        mobile: [
          {
            required: false,
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "手机号码有误，请重填",
            trigger: "blur",
          },
        ],
      },
      saveI: require("@/assets/icons/编辑@2x.png"),
      activeTab: "basic",
      contactData: null,
      sex: [
        {
          value: 1,
          label: "男",
        },
        {
          value: 2,
          label: "女",
        },
      ],
      area: regionData,
      lockSave: false,
      tabs: [
        {
          id: 1,
          name: "基本信息",
          type: "basic",
          show: true,
        },
        {
          id: 2,
          name: "操作日志",
          type: "log",
          show: true,
        },
      ],
    };
  },
  computed: {
    contact() {
      return this.$store.state.app.contact;
    },
  },
  mounted() {
    if (!this.contact) {
      this.$router.go(-1);
    }
    this.getContact();
  },
  methods: {
    async onCheckTel(obj) {
      try {
        const res = await checkPhone({
          account_id: this.$store.state.user.token.account_id,
          remark_mobiles: obj.tel,
          contacts_id: this.$route.query.id,
        });
        obj.errorMsg = res.msg;
        obj.code = res.code;
      } catch (error) {
        console.log(error);
      }
    },
    async getContact() {
      const contactData = await readContacts({
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.app.contact.owner,
        id: this.$route.query.id,
      });
      const res = contactData.data;
      res.mobile = res.mobile.map((i) => {
        return {
          tel: i,
          errorMsg: "",
          code: 0,
        };
      });
      this.contactData = res;
      if (contactData.data.address) {
        const ads = contactData.data.address.split(",");
        this.contactData.addressCode = TextToCode[ads[0]][ads[1]][ads[2]].code;
      }
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.onSave();
          return true;
        } else {
          return false;
        }
      });
    },
    async onSave() {
      if (Array.isArray(this.contactData.addressCode)) {
        const province = CodeToText[this.contactData.addressCode[0]];
        const city = CodeToText[this.contactData.addressCode[1]];
        const area = CodeToText[this.contactData.addressCode[2]];
        this.contactData.address = `${province},${city},${area}`;
      }
      Reflect.deleteProperty(this.contactData, "addressCode");
      const contactMobiles = this.contactData.mobile;
      const mobile = []; //存放需要传递给数据库的手机格式
      // 手机号验证
      let flag = false;
      for (let i = 0; i < contactMobiles.length; i++) {
        const item = contactMobiles[i];
        if (item.code == 99) {
          // 验证不通过
          this.$message({
            type: "error",
            message: item.errorMsg,
          });
          flag = true;
          return;
        }

        if (!item.tel) {
          // 空手机号
          const errorMsg = "手机号不能为空";
          this.$message({
            type: "error",
            message: errorMsg,
          });
          item.code = 99;
          item.errorMsg = errorMsg;
          flag = true;
          return;
        }
        // 验证通过
        mobile.push(item.tel);
      }
      if (flag) {
        return;
      }
      this.contactData.mobile = mobile;
      let params = Object.assign(this.contactData, {
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.app.contact.owner,
      });
      this.lockSave = true;
      const res = await editContacts(params);
      this.lockSave = false;
      if (res.code == 1) {
        this.$message({
          type: "success",
          message: res.msg,
        });
      }
      // 修改为前端可以用于展示错误信息的数组
      this.contactData.mobile = contactMobiles;
    },
    changeTab(type) {
      this.activeTab = type;
      switch (this.activeTab) {
        case "basic":
          this.getContact();
          break;
        default:
          break;
      }
    },
    addPhone(item) {
      item.push({
        tel: "",
        errorMsg: "",
        code: 0,
      });
    },
    delPhone(arr, index) {
      if (arr.length === 1) {
        arr[0] = {
          tel: "",
          errorMsg: "",
          code: 0,
        };
        arr.push();
        return;
      }
      arr.splice(index, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/detail.scss";
.contact-detail {
  height: 100%;
  margin: 20px;
}
.phone-line {
  margin-top: 12px;
  display: flex;
}
.phone-line:nth-child(1) {
  margin-top: 6px;
}
.add-btn {
  margin-left: 10px;
  height: 100%;
}
.tabs-container {
  margin-top: 0;
}
</style>